export function loadImage(src) {
  const imgEl = new Image();
  imgEl.src = src;
  // imgEl.onload = function() {
  //   console.log('loaded', src);
  // };
}
